/// <reference path="../html-templates/progress.html" />
/// <reference path="../html-templates/progress.html" />
(function () {
    'use strict';

    var app = angular.module('app');

    app.filter('time', function() {

        var conversions = {
            'ss': angular.identity,
            'mm': function(value) { return value * 60; },
            'hh': function(value) { return value * 3600; }
        };

        var padding = function(value, length) {
            var zeroes = length - ('' + (value)).length,
                pad = '';
            while(zeroes-- > 0) pad += '0';
            return pad + value;
        };

        return function(value, unit, format, isPadded) {
            var totalSeconds = conversions[unit || 'ss'](value),
                hh = Math.floor(totalSeconds / 3600),
                mm = Math.floor((totalSeconds % 3600) / 60),
                ss = totalSeconds % 60;

            format = format || 'hh:mm';
            isPadded = angular.isDefined(isPadded)? isPadded: true;
            hh = isPadded? padding(hh, 2): hh;
            mm = isPadded? padding(mm, 2): mm;            

            return format.replace(/hh/, hh).replace(/mm/, mm);
        };
    });

    app.filter('teststatus', function ($rootScope) {
        return function (value) {
            if(!value)
                return '';
                        
            if (value.toUpperCase() == 'ACCETTATO' && $rootScope.isAuthorized('DOCENTE'))
                value = 'Disponibile';
            
            return value;
        };
    });

    app.filter('contrattoincontristato', function () {
        return function (value) {
            if (value)
                return '<span><i class="fa fa-circle green"></i> Si</span>';
            else
                return '<span><i class="fa fa-circle red"></i> No</span>';
        };

    });

    app.filter('teststatusicon', ['$translate', '$rootScope', function ($translate, $rootScope) {
        return function (value) {
            if (!value)
                return '';

            if (value.toUpperCase() == 'ACCETTATO' && $rootScope.isAuthorized('DOCENTE'))
                value = 'Disponibile';

            //Aggiungo l'icona
            if (value.toUpperCase() == 'ACCETTATO' || value.toUpperCase() == 'DISPONIBILE' || value.toUpperCase() == 'PUBBLICATO') {
                value = $translate.instant(value);
                return '<span class="status-label">' + value + '</span><span class="status green"></span>';
            }
            else if (value.toUpperCase() == 'IN LAVORAZIONE') {
                value = $translate.instant('InLavorazione');
                return '<span class="status-label">' + value + '</span><span class="status gray"></span>';
            }
            else if (value.toUpperCase() == 'IN VERIFICA') {
                value = $translate.instant('InVerifica');
                return '<span class="status-label">' + value + '</span><span class="status yellow"></span>';
            }
            else if (value.toUpperCase() == 'RIFIUTATO') {
                value = $translate.instant(value);
                return '<span class="status-label">' + value + '</span><span class="status red"></span>';
            }

            return value;
        };
    }]);

    app.filter('teststatusicon_asl', function () {
        return function (value, studenteId) {
            if (!value)
                return '';

            if (value.toUpperCase() == 'ACCETTATO' && studenteId == 0)
                value = 'Disponibile';

            //Aggiungo l'icona
            if (value.toUpperCase() == 'ACCETTATO' || value.toUpperCase() == 'DISPONIBILE')
                return '<span class="status-label"><span><i class="status green"></i>' + value + '</span></span>';
            else if (value.toUpperCase() == 'IN LAVORAZIONE')
                return '<span class="status-label"><span><i class="status gray"></i>' + value + '</span></span>';
            else if (value.toUpperCase() == 'IN VERIFICA')
                return '<span class="status-label"><span><i class="status yellow"></i>' + value + '</span></span>';
            else if (value.toUpperCase() == 'RIFIUTATO')
                return '<span class="status-label"><span><i class="status red"></i>' + value + '</span></span>';

            return value;
        };
    });

    app.filter('authoricon', function ($rootScope) {
        return function (value, studenteId) {
            if (!value)
                return '';

            if (!studenteId || studenteId == 0)
                return value + '<img src="/content/images/teacher.png" class="img-table-role" alt="Docente" />';
            else
                return value + '<img src="/content/images/student.png" class="img-table-role" alt="Studente" />';
        };
    });

    app.filter('contrattovalido', function () {
        return function (value) {
            if (value)
                return '<span><i class="fa fa-circle green"></i> Si</span>';
            else
                return '<span><i class="fa fa-circle red"></i> No</span>';
        };
    });

    app.filter('contrattoattachstato', function () {
        return function (value) {

            if (value == 0)
                return '<span><i class="fa fa-circle gray"></i> Da Visionare</span>';
            else if (value == 1)
                return '<span><i class="fa fa-circle green"></i> Accettato</span>';
            else
                return '<span><i class="fa fa-circle red"></i> Rifiutato</span>';
        };
    });

    app.filter('strumentoFinanziario', function () {
        return function (value) {

            if (value == "P")
                return "PayPal o Carta di Credito";
            else if (value == "B")
                return "Bonifico";
            else if (value == "A")
                return "Assegno";
            if (value == "CD")
                return "Voucher Carta Docente";
            else
                return "Contanti";
        };
    });

    app.filter('annoClasse', function () {
        return function (value) {
            if (!value || value.length == 0)
                return "";

            var iValue = parseInt(value);
            return iValue + "/" + ((iValue + 1).toString().substring(2, 4));
        };
    });

    app.filter('difficoltaTest', ['$translate', function ($translate) {        
        return function (value) {
            if (value == undefined || value.length == 0)
                return "";

            if (value == '0')
                return "<img src='/content/images/seasy.png' alt='Facile' />";
            else if (value == '1')
                return "<img src='/content/images/smedium.png' alt='Medio' />";
            else if (value == '2')
                return "<img src='/content/images/shard.png' alt='Difficile' />";
        };
    }]);

    app.filter('difficoltaTestModalePacchetto', ['$translate', function ($translate) {
        return function (value) {
            if (value == undefined || value.length == 0)
                return "";

            if (value == '0')
                return "<span class='easy'></span>";
            else if (value == '1')
                return "<span class='medium'></span>";
            else if (value == '2')
                return "<span class='hard'></span>";
        };
    }]);

    app.filter('votoTest', function () {
        return function (voto) {
            if (voto == undefined)
                return;

            var parteIntera = parseInt(voto);
            var decimale = Math.round((voto - parteIntera) * 10);

            var risultato = '';
            if (voto < 2)
                risultato = '2';
            else if (decimale >= 1 && decimale <= 3)
                risultato = parteIntera + '+';
            else if (decimale >= 4 && decimale <= 6)
                risultato = parteIntera + '½';
            else if (decimale >= 7 && decimale <= 9)
                risultato = parteIntera + 1 + '-';
            else {
                if (voto == 10) risultato = voto;
                else risultato = voto.toString().substring(0, 1);
            }

            return '<span>' + risultato + '</span>';
        };
    });  

    app.filter('profileImage', function () {
        return function (icona, sesso) {
            var face = 'faceOne';

            if (sesso == undefined || icona == undefined || icona == '0')
                return face;

            var i = icona.substring(0, 1);
            switch (i) {
                case '1': face = 'faceOne';
                    break;
                case '2': face = 'faceTwo';
                    break;
                case '3': face = 'faceThree';
                    break;
                case '4': face = 'faceFour';
                    break;
                case '5': face = 'faceFive';
                    break;
                case '6': face = 'faceSix';
                    break;
                case '7': face = 'faceSeven';
                    break;
                default: face = 'faceOne';
                    break;
            }

            return face;
        };
    });

    app.filter('profileImageColor', function () {
        return function (icona, sesso) {
            var defaultColor;
            var color = 'lightcyan';

            if (sesso == undefined)
                return color;

            if (sesso == 'F')
                defaultColor = 'pink';
            else
                defaultColor = 'lightcyan';

            if (icona == undefined || icona == '0')
                return defaultColor;

            var i = icona.substring(1, 2);
            switch (i) {
                case '1': color = 'lightwhite';
                    break;
                case '2': color = 'pink';
                    break;
                case '3': color = 'lightcyan';
                    break;
                case '4': color = 'lightbrown';
                    break;
                case '5': color = 'aqua';
                    break;
                case '6': color = 'lightyellow';
                    break;
                case '7': color = 'lightorange';
                    break;
                default: color = defaultColor;
                    break;
            }

            return color;
        };
    });

    app.filter('profileSessionCount', function () {
        return function (sessioni) {
            var classe = 'beginner';

            if (sessioni == undefined)
                return classe;
            if (sessioni >= 0 && sessioni < 9)
                return classe;
            if (sessioni >= 10 && sessioni < 24)
                return 'bronze';
            if (sessioni >= 25 && sessioni < 49)
                return 'silver';
            if (sessioni >= 50)
                return 'gold';

            return classe;
        };
    });

    //*************************************************************
    /* Direttive create per verifica del funzionamento e dell'inclusione     */
    //*************************************************************
    app.directive('myCustomer', function () {
        return {
            template: 'Name: NOME Address: INDIRIZZO'
        };
    });

    app.directive('lunghezza', function () {
        var directive = {
            require: 'ngModel',
            link: link
        };
        return directive;

        function link(scope, elm, attrs, ctrl) {

            function validate(value) {
                if (value == null) return false;

                if (value.length > 3) {
                    ctrl.$setValidity('lunghezza', true);
                    return true;
                } else {
                    ctrl.$setValidity('lunghezza', false);
                    return false;
                }
            }

            scope.$watch(function () {
                return ctrl.$viewValue;
            }, validate);
        }
    });

    app.directive('imageLoader', function () 
    { 
        return {
            restrict: "E",
            scope: {
                dim: '=dim'
            },
            templareUrl: '/app/common/loader.html'
        };
    }); 

    app.directive('ccImageLoader', function () {
        var directive = {};

        directive.restrict = 'E'; /* restrict this directive to elements */
        directive.transclude = true;
        directive.templateUrl = "/app/html-templates/loader.html?version=43";

        return directive;
    });
    //*************************************************************

    app.directive('typeaheadCheckId', function () {
        //Usage:
        //Controlla che l'oggetto abbia una prorpietà Id
        var directive = {
            require: 'ngModel',
            link: link
        };
        return directive;

        function link(scope, elm, attrs, ctrl) {

            function validate(value) {
                var isValid = false;

                if (value == null) {
                    return false;
                }

                if (value.Id) {
                    isValid = true;
                }

                ctrl.$setValidity('typeaheadCheckId', isValid);
                return isValid;
            }

            scope.$watch(function () {
                return ctrl.$modelValue;
            }, validate);
        }
    });

    app.directive('ccImgPerson', ['config', function (config) {
        //Usage:
        //<img data-cc-img-person="{{s.speaker.imageSource}}"/>
        var basePath = config.imageSettings.imageBasePath;
        var unknownImage = config.imageSettings.unknownPersonImageSource;
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$observe('ccImgPerson', function (value) {
                value = basePath + (value || unknownImage);
                attrs.$set('src', value);
            });
        }
    }]);

    app.directive('ccSidebar', function () {
        // Opens and clsoes the sidebar menu.
        // Usage:
        //  <div data-cc-sidebar>
        // Creates:
        //  <div data-cc-sidebar class="sidebar">
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $sidebarInner = element.find('.sidebar-inner');
            var $dropdownElement = element.find('.sidebar-dropdown a');
            element.addClass('sidebar');
            $dropdownElement.click(dropdown);

            function dropdown(e) {
                var dropClass = 'dropy';
                e.preventDefault();
                if (!$dropdownElement.hasClass(dropClass)) {
                    hideAllSidebars();
                    $sidebarInner.slideDown(350);
                    $dropdownElement.addClass(dropClass);
                } else if ($dropdownElement.hasClass(dropClass)) {
                    $dropdownElement.removeClass(dropClass);
                    $sidebarInner.slideUp(350);
                }

                function hideAllSidebars() {
                    $sidebarInner.slideUp(350);
                    $('.sidebar-dropdown a').removeClass(dropClass);
                }
            }
        }
    });

    app.directive('ccWidgetClose', function () {
        // Usage:
        // <a data-cc-widget-close></a>
        // Creates:
        // <a data-cc-widget-close="" href="#" class="wclose">
        //     <i class="fa fa-remove"></i>
        // </a>
        var directive = {
            link: link,
            template: '<i class="fa fa-remove"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('href', '#');
            attrs.$set('wclose');
            element.click(close);

            function close(e) {
                e.preventDefault();
                element.parent().parent().parent().hide(100);
            }
        }
    });

    app.directive('ccWidgetMinimize', function () {
        // Usage:
        // <a data-cc-widget-minimize></a>
        // Creates:
        // <a data-cc-widget-minimize="" href="#"><i class="fa fa-chevron-up"></i></a>
        var directive = {
            link: link,
            template: '<i class="fa fa-chevron-up"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            //$('body').on('click', '.widget .wminimize', minimize);
            attrs.$set('href', '#');
            attrs.$set('wminimize');
            element.click(minimize);

            function minimize(e) {
                e.preventDefault();
                var $wcontent = element.parent().parent().next('.widget-content');
                var iElement = element.children('i');
                if ($wcontent.is(':visible')) {
                    iElement.removeClass('fa fa-chevron-up');
                    iElement.addClass('fa fa-chevron-down');
                } else {
                    iElement.removeClass('fa fa-chevron-down');
                    iElement.addClass('fa fa-chevron-up');
                }
                $wcontent.toggle(500);
            }
        }
    });

    app.directive('ccScrollToTop', ['$window', function ($window) {
        // Usage:
        // <span data-cc-scroll-to-top></span>
        // Creates:
        // <span data-cc-scroll-to-top="" class="totop">
        //      <a href="#"><i class="fa fa-chevron-up"></i></a>
        // </span>
        var directive = {
            link: link,
            template: '<a href="#"><i class="fa fa-chevron-up"></i></a>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $win = $($window);
            element.addClass('totop');
            $win.scroll(toggleIcon);

            element.find('a').click(function (e) {
                e.preventDefault();
                // Learning Point: $anchorScroll works, but no animation
                //$anchorScroll();
                $('body').animate({ scrollTop: 0 }, 500);
            });

            function toggleIcon() {
                $win.scrollTop() > 300 ? element.slideDown() : element.slideUp();
            }
        }
    }]);

    app.directive('ccSpinner', ['$window', function ($window) {
        // Description:
        //  Creates a new Spinner and sets its options
        // Usage:
        //  <div data-cc-spinner="vm.spinnerOptions"></div>
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.spinner = null;
            scope.$watch(attrs.ccSpinner, function (options) {
                if (scope.spinner) {
                    scope.spinner.stop();
                }
                scope.spinner = new $window.Spinner(options);
                scope.spinner.spin(element[0]);
            }, true);
        }
    }]);

    app.directive('ccWidgetHeader', function () {
        //Usage:
        //<div data-cc-widget-header title="vm.map.title"></div>
        var directive = {
            link: link,
            scope: {
                'title': '@',
                'subtitle': '@',
                'rightText': '@',
                'allowCollapse': '@'
            },
            templateUrl: '/app/layout/widgetheader.html?version=43',
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('class', 'widget-head');
        }
    });
	
    app.directive('crop', ['$window', function ($window) {
    	// Description:
    	//  Creates a new Spinner and sets its options
    	// Usage:
    	//  <div data-cc-spinner="vm.spinnerOptions"></div>
    	var directive = {
    		link: link,
    		restrict: 'A'
    	};
    	return directive;

    	function link(scope, element, attrs) {
    		//angular.element(element[0]).querySelector('#fileInput');

    		//console.dir($window.document.querySelector('#fileInput'));


    		var handleFileSelect = function (evt) {
    			console.log('handleFileSelect');
    			var file = evt.currentTarget.files[0];
    			var reader = new FileReader();
    			reader.onload = function (evt) {
    				scope.$apply(function (scope) {
    					scope.myImage = evt.target.result;
    					scope.cropper.sourceImage = evt.target.result;
    				});
    			};
    			reader.readAsDataURL(file);
    		};

    		angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    	}
    }]);
	

    app.directive('imageonload', function () {
    	return {
    		restrict: 'A',
    		link: function (scope, element, attrs) {
    			element.bind('load', function () {
    				//call the function that was passed
    				scope.$apply(attrs.imageonload);
    			});
    		}
    	};
    });

    //*************************************************************
    /* Direttiva per copia e incolla dell'immagine               */
    /*                                                           */
    //*************************************************************
    app.directive('copypasteimage', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                /*Registrazione eventi */
                (function ($) {
                    var defaults;
                    $.event.fix = (function (originalFix) {
                        return function (event) {                            
                            event = originalFix.apply(this, arguments);
                            if (event.type.indexOf('copy') === 0 || event.type.indexOf('paste') === 0) {                                
                                event.clipboardData = event.originalEvent.clipboardData;                                
                            }
                            return event;
                        };
                    })($.event.fix);
                    defaults = {
                        callback: $.noop,
                        matchType: /image.*/
                    };
                    return $.fn.pasteImageReader = function (options) {
                        if (typeof options === "function") {
                            options = {
                                callback: options
                            };
                        }
                        options = $.extend({}, defaults, options);
                        return this.each(function () {                            
                            var $this;
                            //element = this;
                            $this = $(this);
                            return element.bind('paste', function (event) {
                                $(element).focus(); 
                               
                                /*if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {
                                    event.preventDefault();
                                }
                                else
                                    scope.firefoxPasteImage = true;*/
                                event.preventDefault();

                                //Chrome                               
                                var clipboardData, found;
                                found = false;
                                var i = 0;
                                if (event.clipboardData && event.clipboardData.types) {
                                    clipboardData = event.clipboardData;
                                    return Array.prototype.forEach.call(clipboardData.types, function (type, i) {
                                        var file, reader;
                                        if (found) {                                            
                                            return;
                                        }
                                        
                                        if (clipboardData.items) {
                                            if (type.match(options.matchType) || clipboardData.items[i].type.match(options.matchType)) {
                                                file = clipboardData.items[i].getAsFile();
                                                reader = new FileReader();
                                                reader.onload = function (evt) {
                                                    return options.callback.call(element, {
                                                        dataURL: evt.target.result,
                                                        event: evt,
                                                        file: file,
                                                        name: file.name
                                                    });
                                                };
                                                reader.readAsDataURL(file);
                                                return found = true;
                                            }
                                        }
                                        else return;
                                    });
                                }
                                //IE, Edge
                                else {                                    
                                    clipboardData = window.clipboardData;
                                    if (clipboardData.files.length == 0){                                        
                                        return;
                                    }
                                    
                                    return Array.prototype.forEach.call(clipboardData.files, function (file, i) {
                                        var reader;
                                        if (found) {                                            
                                            return;
                                        }                                       
                                        if (clipboardData.files[i].type.match(options.matchType)) {
                                            file = clipboardData.files[i];
                                            reader = new FileReader();
                                            reader.onload = function (evt) {
                                                return options.callback.call(element, {
                                                    dataURL: evt.target.result,
                                                    event: evt,
                                                    file: file,
                                                    name: file.name
                                                });
                                            };
                                            reader.readAsDataURL(file);                                            
                                            return found = true;
                                        }                                       
                                    });
                                }
                            });
                        });
                    };
                })(jQuery);               

                $("html").pasteImageReader(function (results) {
                    if (!element.hasClass('cpimg-active'))
                        return;
                   
                    var dataURL, filename;
                    filename = results.filename, dataURL = results.dataURL;
                    scope.choice.image = dataURL;
                    
                    if (!scope.$$phase)
                        scope.$apply();
                });

                $('.cpimg-target').on('click', function () {
                    var $this = $(this);

                    $('#text').css('border', 'solid 1px #ccc');
                    $this.toggleClass('cpimg-active');
                    $this.toggleClass('cpimg-contain');
                });
            }
        };
    });

    //*************************************************************
    /* Direttiva per just gage                                   */
    /* I nomi devono essere in minuscolo                         */
    //*************************************************************
    app.directive('justgage',
    function () {
        return {
            restrict: 'EAC',
            scope: {
                title: '@',                       // gauge title text
                titlefontcolor: '@',              // title text color

                value: '@',                       // value to show
                valuefontcolor: '@',              // color of value text

                width: '@',                       // gauge width
                height: '@',                      // gauge height
                relativegaugesize: '@',           // true if the gauge has to grow with the container

                min: '@',                         // minimum value
                max: '@',                         // maximum value

                valueminfontsize: '@',            // absolute minimum font size for the value
                titleminfontsize: '@',            // absolute minimum font size for the title
                labelminfontsize: '@',            // absolute minimum font size for the label
                minlabelminfontsize: '@',         // absolute minimum font size for the minimum label
                maxlabelminfontsize: '@',         // absolute minimum font size for the maximum label

                hidevalue: '@',                   // hide value text
                hideminmax: '@',                  // hide min and max values
                hideinnershadow: '@',             // hide inner shadow

                gaugewidthscale: '@',             // width of the gauge element
                gaugecolor: '@',                  // background color of gauge element

                showinnershadow: '@',             // true to display inner shadow
                shadowopacity: '@',               // shadow opacity, values 0 ~ 1
                shadowsize: '@',                  // inner shadow size
                shadowverticaloffset: '@',        // how much is shadow offset from top

                levelcolors: '@',                 // array of strings, colors of indicator, from lower to upper, in hex format
                customsectors: '@',               // Array of objects with color, hi, lo attributes
                nogradient: '@',                  // true to use sector-based color change, false to use gradual color change

                label: '@',                       // text to show below value
                labelfontcolor: '@',              // color of label under the value

                startanimationtTime: '@',          // length of initial load animation
                startanimationtype: '@',          // type of initial animation (linear, >, <, <>, bounce)
                refreshanimationtime: '@',        // length of refresh animation
                refreshanimationtype: '@',        // type of refresh animation (linear, >, <, <>, bounce)

                donut: '@',                       // Turn the gauge into a full circle donut
                donutstartangle: '@',             // angle to start from when in donut mode

                counter: '@',                     // Increase numbers one by one
                decimals: '@',                    // Quantity of decimal numbers to show
                symbol: '@',                      // Unit of measure that will be appended to value
                formatnumber: '@',                // Whether to format numbers
                humanfriendly: '@',               // true to show shorthand big numbers (300K instead of 300XXX)
                humanfriendlydecimal: '@',        // number of decimal places for our human friendly number to contain

                textrenderer: '&'                 // function applied before rendering text
            },
            controller: 'justgageCtrl',
            link: function (scope, element, attrs, justgageCtrl) {
                var justgage,
                    watchers = [];

                /**
                 * Bind the `value` property on the scope in order to refresh the JustGage when it changes.
                 */
                var bindValue = function () {
                    watchers.push(scope.$watch('value', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            justgage.refresh(newValue, scope.max);
                        }
                    }));
                    watchers.push(scope.$watch('max', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            justgage.refresh(scope.value, newValue);
                        }
                    }));
                };

                /**
                 * Bind all scope paramenters other than `value` and `textRenderer` and re-creates the JustGage whenever
                 * one of them changes.
                 */
                var bindOtherOptions = function () {
                    var otherOptionsNames = justgageCtrl.getOptionsNames(['value', 'max']);
                    // TODO: move to angularjs 1.3 and replace with $watchGroup
                    angular.forEach(otherOptionsNames, function (name) {
                        watchers.push(scope.$watch(name, function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                init();
                            }
                        }));
                    });
                };

                /**
                 * Initialize the JustGage element with the given non-undefined options on the scope.
                 * It also binds the scope values to appropriate changes
                 */
                var init = function () {
                    var justgageOptions = {
                        parentNode: element[0]
                    };
                    angular.extend(justgageOptions, justgageCtrl.getDefinedOptions());

                    // Remove existing canvas from DOM (if any)
                    if (justgage) {
                        var canvasDom = justgage.canvas.canvas;
                        canvasDom.parentNode.removeChild(canvasDom);
                    }

                    // Clear existing watcher (see http://stackoverflow.com/a/17306971 why while & pop)
                    while (watchers.length > 0) {
                        var watcher = watchers.pop();
                        watcher();
                    }

                    // rebuild the gage
                    //console.dir(justgageOptions);
                    justgage = new JustGage(justgageOptions);

                    // Bind scope changes to element methods
                    bindValue();
                    bindOtherOptions();
                };

                // Initialize everything on the next $digest cycle
                init();
            }
        };
    });

    //*************************************************************
    /* Direttive Progress Bar     */
    //*************************************************************
    app.directive('progressbar', function () {
        return {
            restrict: 'C',
            scope: {
                valuecurrent: '@',
                valuemax: '@'
            },
            link: function (scope, element, attrs) {
                scope.warning = parseInt(scope.valuecurrent) > parseInt(scope.valuemax);
            },
            templateUrl: '/app/html-templates/progress.html?version=43'
        }        
    });

    app.directive('progressbarperc', function () {
        return {
            restrict: 'C',
            scope: {
                valuecurrent: '@',
                valuemax: '@',
            },
            link: function (scope, element, attrs) {
                scope.warning = parseInt(scope.valuecurrent) > parseInt(scope.valuemax);
            },
            templateUrl: '/app/html-templates/progressPerc.html?version=43'
        }
    });   

    //*************************************************************
	/* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
	//*************************************************************
    angular.module('app').directive('formInit', function () {
    	return {
    		restrict: 'A',
    		scope: {
    			init: '&formInit'
    		},
    		controller: function ($scope, $element) {
    			var name = null;
    			if ($element[0] && $element[0].name) {
    				name = $element[0].name;
    			}

    			var listener = $scope.$watch('init', function () {
    				if ($scope[name] && $scope.init) {
    					$scope.init();
    					listener();
    				}
    			});
    		}
    	};
    });    


	//*************************************************************
	/* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
	//*************************************************************
    angular.module('app').directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    };
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        };
    }]);

    angular.module('app').directive('clickme', function () {
        return function (scope, element, attrs) {
            var clickingCallback = function () {
                $("#image_file").trigger('click');
            };
            element.bind('click', clickingCallback);
        };
    });

    //*************************************************************
    /* Direttive TAG                                             */
    //*************************************************************
    angular.module('app').directive('tag', function ($compile, datacontext, common, $translate) {
        return {
            restrict: "A",
            scope: {
                actualvalues: '=',
                idparent: '=',
                disabled: '=ngDisabled'
            },
            templateUrl: '/app/html-templates/tag.html',
            link: function (scope, element, attrs) {
                scope.newvalues = '';
                
                scope.searchItems = [];
                //Sort Array
                scope.searchItems.sort();
                //Define Suggestions List
                scope.suggestions = [];
                scope.suggestionsObj = [];
                //Define Selected Suggestion Item
                scope.selectedIndex = -1;
                scope.indexLastComma = 0;

                //Function To Call On ng-change
                scope.search = function () {
                    scope.suggestions = [];
                    scope.suggestionsObj = [];

                    var myMaxSuggestionListLength = 0;

                    if (!scope.newvalues || scope.newvalues.length == 0)
                        return;

                    var tags = scope.actualvalues;
                    var arrayTag = tags != null ? tags.split(',') : new Array();

                    if (scope.newvalues.split(' ').join('').length < 3) return; //numero minimo di caratteri

                    return datacontext.tag_getAllList(scope.idparent, scope.newvalues, 0).then(function (data) {

                        if (data) {
                            scope.suggestions = [];
                            scope.selectedIndex = -1;
                            data.forEach(function (item) {
                                var bExists = false;
                                arrayTag.forEach(function (tag) {
                                    if (tag.split(' ').join('').toLowerCase() == item.Name.split(' ').join('').toLowerCase() && tag.length === item.Name.length) {
                                        bExists = true;
                                    }

                                });
                                if (!bExists) {
                                    scope.suggestions.push(item.Name);
                                    scope.suggestionsObj.push(item);
                                }
                            });
                        }
                    });
                };

                //List Item Events
                //Function To Call on ng-click
                scope.assignValueAndHide = function (index) {
                    scope.setSearchText(index);

                    scope.suggestions = [];
                    scope.suggestionsObj = [];
                };
                //======================================

                //Keep Track Of Search Text Value During The Selection From The Suggestions List  
                scope.$watch('selectedIndex', function (val) {
                    if (val === -1) {
                        scope.suggestions = [];
                        scope.suggestionsObj = [];
                    }
                });

                scope.checkKeyDown = function (event) {
                    if (event.keyCode === 40) {//down key, increment selectedIndex
                        event.preventDefault();
                        if (scope.selectedIndex + 1 < scope.suggestions.length)
                            scope.selectedIndex++;
                        else
                            scope.selectedIndex = scope.suggestions.length - 1;

                        scope.setSearchText(scope.selectedIndex);
                    } else if (event.keyCode === 38) { //up key, decrement selectedIndex
                        event.preventDefault();
                        if (scope.selectedIndex - 1 > -1)
                            scope.selectedIndex--;
                        else
                            scope.selectedIndex = 0;

                        scope.setSearchText(scope.selectedIndex);
                    }
                    else if (event.keyCode === 13) { //enter key, empty suggestions array
                        var getLogFn = common.logger.getLogFn;
                        var log = getLogFn('StakTest');
                        event.preventDefault();
                        scope.suggestions = [];
                        scope.suggestionsObj = [];

                        //controllo se viene inserito un duplicato
                        var tags = scope.actualvalues;
                        var arrayTag = tags != null ? tags.split(',') : new Array();
                        var bExist = false;
                        arrayTag.forEach(function (tag) {
                            if (tag.split(' ').join('').toLowerCase() == scope.newvalues.split(' ').join('').toLowerCase() && tag.length === scope.newvalues.length) {
                                bExist = true;
                            }

                        });

                        if (bExist) return;

                        if (scope.newvalues.split(' ').join('').length < 4) return log($translate.instant('InserisciCaratteri'));

                        //imposto il nuovo testo nella casella di autocomplete
                        scope.setSearchText(scope.selectedIndex);

                        scope.actualvalues = scope.actualvalues + ',';
                    }
                };

                scope.setSearchText = function (index) {
                    if (typeof (scope.newvalues) != 'undefined' && typeof (scope.suggestionsObj) != 'undefined' && index >= 0 && index < scope.suggestionsObj.length) {
                        if (scope.actualvalues == null || scope.actualvalues.length == 0)
                            scope.actualvalues = scope.suggestionsObj[index].Name; // + ',';
                        else
                            scope.actualvalues = scope.actualvalues + ',' + scope.suggestionsObj[index].Name; // + ',';

                        scope.newvalues = '';
                    }
                    else if (typeof (scope.newvalues) != 'undefined' && scope.newvalues.length > 3) {
                        var newTag = scope.newvalues.split(' ').join('');
                        if (newTag.length > 3) {
                            if (scope.actualvalues == null || scope.actualvalues.length == 0)
                                scope.actualvalues = newTag;
                            else
                                scope.actualvalues = scope.actualvalues + ',' + newTag;
                            scope.newvalues = '';
                        }
                    }
                };

                scope.deleteWord = function (index) {
                    var arrayTag = scope.actualvalues.split(',');
                    arrayTag.splice(index, 1);
                    scope.actualvalues = arrayTag.join(',');
                };
            }
        };


    });

    //*************************************************************
    /* Direttive Dropdown Multiple Select                        */
    //*************************************************************
    app.directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse', '$translate', function ($filter, $document, $compile, $parse, $translate) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                groupBy: '@'
            },
            template: function (element, attrs) {
                var checkboxes = attrs.checkboxes ? true : false;
                var groups = attrs.groupBy ? true : false;

                var template = '<div class="multiselect-parent btn-group dropdown-multiselect">';
                template += '<button type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()">{{getButtonText()}}&nbsp;<span class="caret"></span></button>';
                template += '<ul class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'block\' : \'none\', height : settings.scrollable ? settings.scrollableHeight : \'auto\' }" style="overflow: scroll" >';
                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll"><a ng-click="deselectAll();"><span class="glyphicon glyphicon-remove"></span>   {{texts.uncheckAll}}</a></li>';
                template += '<li ng-hide="(!settings.showCheckAll || settings.selectionLimit > 0) && !settings.showUncheckAll" class="divider"></li>';
                template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                template += '<li ng-show="settings.enableSearch" class="divider"></li>';

                if (groups) {
                    template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                    template += '<li ng-repeat-end role="presentation">';
                } else {
                    template += '<li role="presentation" ng-repeat="option in options | filter: searchFilter">';
                }

                template += '<a role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp))">';

                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> <span ng-if="!setting.template">{{getPropertyForObject(option, settings.displayProp)}}</label></div></a>';
                } else {
                    template += '<span ng-class="{\'glyphicon glyphicon-ok\': isChecked(getPropertyForObject(option,settings.idProp))}"></span> {{getPropertyForObject(option, settings.displayProp)}}</a>';
                }

                template += '</li>';

                template += '<li class="divider" ng-show="settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function ($scope, $element, $attrs) {
                var $dropdownTrigger = $element.children()[0];

                $scope.toggleDropdown = function () {
                    $scope.open = !$scope.open;
                };

                $scope.checkboxClick = function ($event, id) {
                    $scope.setSelectedItem(id);
                    $event.stopImmediatePropagation();
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 0,
                    showCheckAll: true,
                    showUncheckAll: true,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop,
                };

                $scope.texts = {
                    checkAll: $translate.instant('SelezionaTutti'),
                    uncheckAll: $translate.instant('DeselezionaTutti'),
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: $translate.instant('Cerca') + '...',
                    buttonDefaultText: $translate.instant('Selezionare'),
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function (e) {
                        var target = e.target.parentElement;
                        var parentFound = false;

                        while (angular.isDefined(target) && target !== null && !parentFound) {
                            if (_.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                if (target === $dropdownTrigger) {
                                    parentFound = true;
                                }
                            }
                            target = target.parentElement;
                        }

                        if (!parentFound) {
                            $scope.$apply(function () {
                                $scope.open = false;
                            });
                        }
                    });
                }

                $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue);
                    }

                    return groupValue;
                };

                $scope.getButtonText = function () {
                    if ($scope.settings.dynamicTitle && ($scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {
                            var itemsText = [];

                            angular.forEach($scope.options, function (optionItem) {
                                if ($scope.isChecked($scope.getPropertyForObject(optionItem, $scope.settings.idProp))) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);

                                    itemsText.push(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                itemsText.push('...');
                            }

                            return itemsText.join(', ');
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            } else {
                                return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                            }
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };

                $scope.selectAll = function () {
                    $scope.deselectAll(false);
                    $scope.externalEvents.onSelectAll();

                    angular.forEach($scope.options, function (value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true);
                    });
                };

                $scope.deselectAll = function (sendEvent) {
                    sendEvent = sendEvent || true;

                    if (sendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    }
                };

                $scope.setSelectedItem = function (id, dontRemove) {
                    var findObj = getFindObj(id);
                    var finalObj = null;

                    if ($scope.settings.externalIdProp === '') {
                        finalObj = _.find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                        angular.extend($scope.selectedModel, finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                        if ($scope.settings.closeOnSelect) $scope.open = false;

                        return;
                    }

                    dontRemove = dontRemove || false;

                    var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

                    if (!dontRemove && exists) {
                        $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
                        $scope.externalEvents.onItemDeselect(findObj);
                    } else if (!exists && ($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit)) {
                        $scope.selectedModel.push(finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);
                    }
                    if ($scope.settings.closeOnSelect) $scope.open = false;
                };

                $scope.isChecked = function (id) {
                    if ($scope.singleSelection) {
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                    }

                    return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.externalEvents.onInitDone();
            }
        };
    }]);


    angular.module('app').directive('performance',
   function () {
       return {
           restrict: 'E',
           //replace: true,
           scope: {
               source: '='
           },

           template: '<div id="chart-{{$id}}" style="max-width: 490px; height: 400px; margin: 0 auto; width: 100%"></div>',
           link: function (scope, element, attrs) {
               var chart = false;

               var initChart = function () {
                   if (chart) chart.destroy();
                   var config = scope.config || {};
                   chart = AmCharts.makeChart("chart-{{$id}}", {
                       "type": "radar",
                       "theme": "light",
                       "dataProvider": scope.source,
                       "valueAxes": [{
                           "axisTitleOffset": 20,
                           "minimum": 0,
                           "axisAlpha": 0.15,
                           "maximum": 100
                       }],
                       "startDuration": 2,
                       "graphs": [{
                           "balloonText": "[[value]]",
                           "bullet": "round",
                           "lineThickness": 2,
                           "valueField": "Punteggio"
                       }],
                       "categoryField": "Materia"
                   });


               };
               initChart();

           }//end watch           
       }
   });

    angular.module('app').directive('didattica',
   function () {
       return {
           restrict: 'E',
           //replace: true,
           scope: {
               source: '='
           },

           template: '<div id="chart-performance_{{$id}}" style="max-width: 490px; height: 400px; margin: 0 auto; width: 100%;"></div>',
           link: function (scope, element, attrs) {
               var chart = false;
               console.info('config', scope.source);
               var initChart = function () {
                   if (chart) chart.destroy();
                   var config = scope.config || {};
                   chart = AmCharts.makeChart("chart-performance_{{$id}}", {
                       "type": "radar",
                       "theme": "light",
                       "dataProvider": scope.source,
                       "valueAxes": [{
                           "axisTitleOffset": 20,
                           "minimum": 0,
                           "axisAlpha": 0.15
                       }],
                       "startDuration": 2,
                       "graphs": [{
                           "balloonText": "[[value]]",
                           "bullet": "round",
                           "lineThickness": 2,
                           "valueField": "litres"
                       }],
                       "categoryField": "country"
                   });


               };
               initChart();

           }//end watch           
       }
   });   

    app.directive('test', function ($window) {
        var directive = {
            link: link,
            restrict: "A"
        };
        return directive;

        function link(scope, element, attrs) {
            scope.onResize = function (width) {
                scope.altezza = 125;//(element[0].clientHeight) / 2;
                var larghezza = 249;//(element[0].clientWidth) / 2;
                if (width)
                    larghezza = width / 2;
                    
                //scope.item = {};
                scope.questionFull = { "height": String(scope.altezza * 2) + "px", "overflow": "hidden" };
                scope.questionMid = { "height": String(scope.altezza) + "px", "overflow": "hidden" };
                scope.qImgFull = { "max-height": String(scope.altezza * 2) + "px" };
                scope.qImgMid = { "max-height": String(scope.altezza) + "px" };
                scope.spinnerStyle = { "top": String(scope.altezza) - 18 + "px", "left": String(larghezza) - 18 + "px" };
            };
            scope.onResize();

            angular.element($window).bind('resize', function () {
                scope.onResize($('#questionContainer').width());
            });
        }
    });

})();